import type { FC, ReactElement } from "react";
import { ResponsiveContainer } from "recharts";
import { CHART_DIMENSIONS } from "./config/chart-config";

interface ChartWrapperProps {
  readonly children: ReactElement;
  readonly height?: number;
  readonly className?: string;
}

/**
 * A wrapper component for charts that provides consistent sizing and responsiveness.
 */
export const ChartWrapper: FC<ChartWrapperProps> = ({
  children,
  height = CHART_DIMENSIONS.height,
  className = "",
}) => {
  return (
    <div style={{ height: `${height}px` }} className={`w-full ${className}`}>
      <ResponsiveContainer width="100%" height="100%">
        {children}
      </ResponsiveContainer>
    </div>
  );
};
